import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { ACCOUNT_API_ROUTE } from 'apiRoutes';
import { MontelAccount } from 'domain/account/interfaces/MontelAccount';
import { Table } from 'components/tables/Table';
import { accountTableColumns } from 'components/account/accountTableColumns';
import { useNavigate } from 'react-router-dom';
import { subscriptionUsersTableColumns } from 'pages/Subscription/subscriptionUsersTableColumns';
import { Text, VStack } from '@montel/montelpro-shared-components-v2';
import { Subscription } from 'domain/subscription/interfaces/Subscription';

const BundledSubscriptionUsersTable: FunctionComponent<{
	subscription: Subscription;
	onUserUnassigned: () => void;
	onUsersLoaded?: any;
}> = ({ subscription, onUserUnassigned, onUsersLoaded }) => {
	const { data, status } = useGetOnMount(
		`${ACCOUNT_API_ROUTE}/GetAccountsBySubscriptionId?SubscriptionId=${subscription.id}`,
	);
	const [accounts, setAccounts] = useState<MontelAccount[]>([]);
	useEffect(() => {
		if (!data) return;

		setAccounts(data);
		onUsersLoaded && onUsersLoaded();
	}, [data]);

	const navigate = useNavigate();

	const onUnassigned = (subscriberId: string) => {
		setAccounts(accounts.filter((a) => a.id != subscriberId));
		onUserUnassigned();
	};

	const columns = useMemo(
		() => [
			accountTableColumns.fullName(),
			accountTableColumns.registeredCompany(),
			accountTableColumns.accountCreated(),
			accountTableColumns.activeStatus(),
			subscriptionUsersTableColumns.unassignSeatAction(
				subscription,
				onUnassigned,
			),
		],
		[accounts],
	);

	return (
		<VStack fullWidth gap="xs">
			<Text>Assigned Users</Text>
			<Table<MontelAccount>
				tableId={`subscription-users-table-${subscription.id}`}
				columns={columns}
				padding="none"
				containerGap="none"
				backgroundColor="transparent"
				requestStatus={status}
				data={accounts}
				withPagination={accounts?.length > 10}
				withSearch={accounts?.length > 10}
				onRowClicked={(row: MontelAccount) => {
					navigate(`/accounts/users/${row.id}`);
				}}
			/>
		</VStack>
	);
};

export default BundledSubscriptionUsersTable;
